import SubmitStep from './SubmitStep.tsx';
import type { UnifiedStressTestInputFields } from './UnifiedStressTest.validation.ts';
import type { StepConfig } from '../../../technical/wizard/StepConfig.ts';

export const config = (): StepConfig<UnifiedStressTestInputFields> => ({
  label: 'Stress test results',
  element: <SubmitStep />,
  fields: [],
});
